import { render, staticRenderFns } from "./SetTel.vue?vue&type=template&id=7003a472&scoped=true"
import script from "./SetTel.vue?vue&type=script&lang=js"
export * from "./SetTel.vue?vue&type=script&lang=js"
import style0 from "./SetTel.vue?vue&type=style&index=0&id=7003a472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7003a472",
  null
  
)

export default component.exports